/* kl-track v1.0 (2026-09-09) — Klaviyo "Added to Cart" onsite event for Shopify themes.
   Passive observer: wraps window.fetch / XMLHttpRequest only to notice a *successful* POST to /cart/add(.js),
   then reads /cart.js and pushes a Klaviyo "Added to Cart" event (standard Klaviyo-Shopify property set).
   Never alters a request or response; every step is try/catch; no-op if klaviyo.js is absent
   (events are queued in window._klOnsite and dropped by Klaviyo for unidentified visitors, by design). */
(function () {
  'use strict';
  try {
    if (window.__klTrackLoaded) return; window.__klTrackLoaded = 'v1.0';
    var origin = location.origin;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var base = origin + root.replace(/\/$/, '');
    var last = { key: '', t: 0 };

    function isAddUrl(u) {
      try {
        var a = document.createElement('a'); a.href = String(u || '');
        if (a.host && a.host !== location.host) return false;
        return /\/cart\/add(\.js)?\/?$/.test(a.pathname);
      } catch (e) { return false; }
    }
    function num(c) { return Math.round(Number(c) || 0) / 100; }
    function fmt(c, cur) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(num(c)); }
      catch (e) { return num(c).toFixed(2) + ' ' + cur; }
    }
    function img(u, w) {
      try {
        if (!u) return ''; u = String(u);
        if (u.indexOf('//') === 0) u = 'https:' + u;
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      } catch (e) { return u || ''; }
    }
    function parseJSON(t) { try { return JSON.parse(t); } catch (e) { return null; } }
    function pickAdded(added, cart) {
      try {
        var it = null;
        if (added && added.items && added.items.length) it = added.items[0];
        else if (added && added.variant_id) it = added;
        if (it && cart.items) for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === it.variant_id) return cart.items[i];
        return (cart.items && cart.items[0]) || it;   // Shopify lists the newest line first
      } catch (e) { return (cart.items && cart.items[0]) || null; }
    }
    function send(added) {
      try {
        fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart || !cart.items || !cart.items.length) return;
            var it = pickAdded(added, cart); if (!it) return;
            var key = it.variant_id + ':' + cart.item_count + ':' + cart.total_price, now = Date.now();
            if (key === last.key && now - last.t < 3000) return;   // de-dupe a double fire
            last = { key: key, t: now };
            var cur = cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            var unit = (it.final_price != null) ? it.final_price : it.price;
            var items = [], names = [], perma = [];
            for (var i = 0; i < cart.items.length; i++) {
              var x = cart.items[i];
              items.push({ ProductID: x.product_id, VariantID: x.variant_id, SKU: x.sku || '', ProductName: x.product_title, VariantName: (x.variant_title && x.variant_title !== 'Default Title') ? x.variant_title : '',
                Quantity: x.quantity, ItemPrice: num(x.final_price != null ? x.final_price : x.price), RowTotal: num(x.final_line_price != null ? x.final_line_price : x.line_price),
                ProductURL: origin + x.url, ImageURL: img(x.image, 720), ProductCategories: x.product_type ? [x.product_type] : [], Vendor: x.vendor || '' });
              names.push(x.product_title); perma.push(x.variant_id + ':' + x.quantity);
            }
            var props = {
              '$value': num(cart.total_price), '$currency_code': cur, 'Currency': cur,
              'AddedItemProductName': it.product_title, 'AddedItemProductID': it.product_id, 'AddedItemVariantID': it.variant_id, 'AddedItemSKU': it.sku || '',
              'AddedItemVariantName': (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '',
              'AddedItemCategories': it.product_type ? [it.product_type] : [], 'AddedItemVendor': it.vendor || '',
              'AddedItemImageURL': img(it.image, 720), 'AddedItemURL': origin + it.url,
              'AddedItemPrice': num(unit).toFixed(2), 'AddedItemPriceFormatted': fmt(unit, cur), 'AddedItemQuantity': it.quantity,
              'ItemNames': names, 'ItemCount': cart.item_count, 'CartTotalFormatted': fmt(cart.total_price, cur),
              'CheckoutURL': base + '/cart/' + perma.join(','),   // Shopify cart permalink: rebuilds this cart on any device
              'CartURL': base + '/cart', 'Items': items
            };
            var q = window.klaviyo || (window._klOnsite = window._klOnsite || []);
            q.push(['track', 'Added to Cart', props]);
          }).catch(function () {});
      } catch (e) {}
    }

    if (typeof window.fetch === 'function') {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var p = _fetch.apply(this, arguments);
        try {
          var url = (typeof input === 'string') ? input : ((input && input.url) || String(input || ''));
          var method = (init && init.method) || (input && input.method) || 'GET';
          if (String(method).toUpperCase() === 'POST' && isAddUrl(url)) {
            p.then(function (res) {
              try { if (res && res.ok) res.clone().text().then(function (t) { send(parseJSON(t)); }).catch(function () { send(null); }); } catch (e) {}
            }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
      var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        try { this.__klAdd = (String(method).toUpperCase() === 'POST' && isAddUrl(url)); } catch (e) {}
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        try {
          if (this.__klAdd) this.addEventListener('load', function () {
            try { if (this.status >= 200 && this.status < 300) send(parseJSON(this.responseText)); } catch (e) {}
          });
        } catch (e) {}
        return _send.apply(this, arguments);
      };
    }
  } catch (e) {}
})();
